import { Pipe, PipeTransform } from '@angular/core';
import { DateBrasilia } from 'src/app/util/date-brasilia.helper';

@Pipe({
  name: 'date',
})
export class DatePipe implements PipeTransform {
  transform(
    date: Date | string | number,
    formatOut: string = 'DD/MM/YYYY',
    formatIn?: string,
    utc?: boolean
  ): string {
    const parsedDate = this.parseDate(date, formatIn, utc);

    return this.formatDate(parsedDate, formatOut);
  }

  private parseDate(
    dateInput: Date | string | number,
    formatIn?: string,
    utc?: boolean
  ): Date {
    let date: Date;

    if (typeof dateInput === 'string') {
      const dateOnlyMatch = dateInput.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        date = new Date(Number(year), Number(month) - 1, Number(day));
      } else {
        date = new Date(dateInput);
      }
    } else if (typeof dateInput === 'number') {
      date = new Date(dateInput);
    } else {
      date = dateInput;
    }

    if (utc) {
      // Se desejar ajustar para UTC-3, use DateBrasilia
      const href = window.location.href;
      const keepLocalTime = href.includes('localhost');

      if (!keepLocalTime) {
        return DateBrasilia.startOfDay(date);
      }
    }

    return new Date(date);
  }

  private formatDate(date: Date, format: string): string {
    const map: { [key: string]: string } = {
      DD: this.padZero(date.getDate()),
      MM: this.padZero(date.getMonth() + 1),
      YYYY: date.getFullYear().toString(),
      HH: this.padZero(date.getHours()),
      mm: this.padZero(date.getMinutes()),
      ss: this.padZero(date.getSeconds()),
    };

    return format.replace(
      /DD|MM|YYYY|HH|mm|ss/g,
      (matched) => map[matched] || matched
    );
  }

  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}
